import { render } from "./SectionCurrentDateTime.vue?vue&type=template&id=3e261a0a"
import script from "./SectionCurrentDateTime.vue?vue&type=script&lang=js"
export * from "./SectionCurrentDateTime.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__